import { BlockStack, Text, SkeletonBodyText } from "@medentic/polaris-react";
import { useTranslation } from "react-i18next";
import { AttendeeHistoryItem } from "@features/events/types";

interface HistoryCardProps {
  history: AttendeeHistoryItem[];
  loading: boolean;
}

export default function HistoryCard({ history, loading }: HistoryCardProps) {
  const { t } = useTranslation();

  if (loading) {
    return <SkeletonBodyText lines={3} />;
  }

  return (
    <BlockStack gap="400">
      <Text variant="headingMd" as="h2">
        {t("attendeeDetails.history.title")}
      </Text>

      {history.length === 0 ? (
        <Text variant="bodyMd" as="p" tone="subdued">
          {t("attendeeDetails.history.noHistory")}
        </Text>
      ) : (
        <BlockStack gap="300">
          {history.map((item) => (
            <BlockStack key={item.id} gap="100">
              <Text variant="bodySm" as="p" tone="subdued">
                {item.date}
              </Text>
              <Text variant="bodyMd" as="p">
                {item.title}
              </Text>
              {item.description && (
                <Text variant="bodyMd" as="p" tone="subdued">
                  {item.description}
                </Text>
              )}
            </BlockStack>
          ))}
        </BlockStack>
      )}
    </BlockStack>
  );
}
